import React, { useState } from "react";
import "./ContactForm.css";
import axios from "axios";
import config from "../config";
import apiClient from "../services/apiClient";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    company: "",
    jobTitle: "",
    message: "",
  });
  const [notification, setNotification] = useState(""); // Notification state

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const BASE_API = config.API_BASE_URL;
    try {
      const response = await axios.post(
        `${BASE_API}send-contact-us-email/`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setNotification("Your message has been sent successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        company: "",
        jobTitle: "",
        message: "",
      });
    } catch (error) {
      setNotification("Failed to send your message. Please try again.");
    }
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      {notification && <div className="notification">{notification}</div>}{" "}
      {/* Notification */}
      <div className="form-group row">
        <div className="form-col">
          <label htmlFor="firstName" className="label">
            First Name:
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            className="input-field"
            required
          />
        </div>
        <div className="form-col">
          <label htmlFor="lastName" className="label">
            Last Name:
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            className="input-field"
            required
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="form-col">
          <label htmlFor="email" className="label">
            Email:
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="input-field"
            required
          />
        </div>
        <div className="form-col">
          <label htmlFor="phoneNumber" className="label">
            Phone Number:
          </label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            className="input-field"
            required
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="form-col">
          <label htmlFor="company" className="label">
            Company:
          </label>
          <input
            type="text"
            id="company"
            name="company"
            value={formData.company}
            onChange={handleChange}
            className="input-field"
          />
        </div>
        <div className="form-col">
          <label htmlFor="jobTitle" className="label">
            Job Title:
          </label>
          <input
            type="text"
            id="jobTitle"
            name="jobTitle"
            value={formData.jobTitle}
            onChange={handleChange}
            className="input-field"
          />
        </div>
      </div>
      <div>
        <label htmlFor="message" className="textarea-label">
          Message:
        </label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          className="textarea-field-message"
          required
        ></textarea>
      </div>
      <button type="submit">Submit</button>
    </form>
  );
};

export const ContactUs = () => {
  return (
    <div className="contact-us-div">
      <div className="contact-us-header">Contact us!</div>
      <div className="contact-us-text">
        Have questions? <br />
        Reach out to us and we will get back to you as soon as possible to
        resolve all of your concerns.
      </div>
      <ContactForm />
    </div>
  );
};

export default ContactUs;
